import { z } from 'zod';

export const FieldTypeEnum = z.enum(['text', 'textarea', 'select', 'number', 'date', 'image']);
export type FieldType = z.infer<typeof FieldTypeEnum>;

/**
 * Settings Field schema.
 */
export const FieldDefinitionSchema = z.object({
  id: z.string(),
  label: z.string().min(1, 'Label is required'),
  type: FieldTypeEnum,
  placeholder: z.string().optional(),
  order: z.number().int().min(0),
  options: z.array(z.string()).optional(),
});

export type FieldDefinition = z.infer<typeof FieldDefinitionSchema>;
